import { sis_giaidoan } from './../models/response/so-diem/sis_giaidoan';
import { apiClient } from './apiClient';
import { BaseCRUDApi } from "./baseCRUDApi";

class GiaiDoanApi extends BaseCRUDApi<sis_giaidoan> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
    SelectConfigThoiGian() {
        return apiClient.get(`giai-doan/thoi-gian`)
    }
}
export const giaiDoanApi = new GiaiDoanApi({ path: 'giai-doan' });